<template>
    <Modal v-if="showing" @close="showing = false" size="md" id="invite-modal">
        <h4 class="modal-title">Invite users via email</h4>
        <Input type="tags" placeholder="Email addresses" label="Email addresses separated by spaces" v-model="newInvite.emails"/>
        <Input type="select" label="Role" width="inline" v-model="newInvite.role">
            <option value="member">Ambassador</option>
            <option value="admin">Admin</option>
        </Input>
        <div class="input input-expand">
            <label>Groups</label>
            <multi-select-search :fetch="_getGroups" v-model="newInvite.groups"></multi-select-search>
        </div>
        <Input type="textarea" placeholder="Invite text" label="Invite text for in invitation email" v-model="newInvite.message" />
        <a href="" class="blue-link">Preview invitiation email</a>
        <template v-slot:modal-actions>
            <Button variant="default" :disabled="newInvite.emails.length===0" @click.native="sendInvites(newInvite)" class="float-right">Add {{newInvite.emails.length}} users</Button>
        </template>
    </Modal>
</template>
<script>
    import Button from '../../components/Button/Button';
    import Modal from "../Modal/Modal";
    import Input from "../Input/Input";
    import {mapActions, mapState} from "vuex";
    import MultiSelectSearch from "../MultiSelectSearch/MultiSelectSearch";

    export default {
        name: 'InviteModal',
        components: {
            MultiSelectSearch,
            Input,
            Modal,
            Button
        },
        props: {
            show: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                newInvite: {
                    groups: [],
                    emails: []
                }
            }
        },
        watch: {
            show: function (showing) {
                if(showing) {
                    this.newInvite = {
                        groups: [],
                        emails: []
                    }
                }
            },
        },
        computed: {
            ...mapState({
                groups: state => state.groups.all,
            }),
            showing: {
                // getter
                get: function () {
                    return this.show;
                },
                // setter
                set: function (newValue) {
                    if(newValue===false){
                        this.$emit('close');
                    }
                }
            }
        },
        mounted () {},
        methods: {
            ...mapActions('invites', [
                '_sendInvites',
            ]),
            ...mapActions('groups', [
                '_getGroups',
            ]),
            sendInvites(invites){
                const groups = invites.groups.map(item=>{
                        return item.uuid;
                });
                invites = invites.emails.map(email=>{
                    return {email: email, role: invites.role, groups: groups, name: email};
                });
                console.log(invites);
                this._sendInvites(invites).then(()=>{
                    this.showing = false;
                    this.$emit("created");
                }).catch(error=>{
                    alert(error);
                });
            }
        }
    }
</script>
<style src="./InviteModal.scss" scoped lang="scss"></style>

